/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 配信者情報
 * @export
 * @interface Distributor
 */
export interface Distributor {
    /**
     * 配信者情報ID
     * @type {number}
     * @memberof Distributor
     */
    id: number;
    /**
     * 配信者 (会社)名
     * @type {string}
     * @memberof Distributor
     */
    name: string;
    /**
     * 配信者 (会社) 説明
     * @type {string}
     * @memberof Distributor
     */
    description: string;
    /**
     * サーバーに保存されたファイルの名前
     * @type {string}
     * @memberof Distributor
     */
    imageFileName?: string | null;
    /**
     * s3に保存されたファイルの名前
     * @type {string}
     * @memberof Distributor
     */
    imageFileNameS3?: string | null;
}

export function DistributorFromJSON(json: any): Distributor {
    return DistributorFromJSONTyped(json, false);
}

export function DistributorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Distributor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'imageFileName': !exists(json, 'image_file_name') ? undefined : json['image_file_name'],
        'imageFileNameS3': !exists(json, 'image_file_name_s3') ? undefined : json['image_file_name_s3'],
    };
}

export function DistributorToJSON(value?: Distributor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'image_file_name': value.imageFileName,
        'image_file_name_s3': value.imageFileNameS3,
    };
}

